
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface OrganizationsFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export function OrganizationsFilter({ searchTerm, onSearchChange }: OrganizationsFilterProps) {
  return (
    <div className="flex items-center space-x-2">
      <div className="relative flex-1">
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar organizações..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8"
        />
      </div>
    </div>
  );
}
